<template>
	<div class="nc-search search__content">
		<div class="nc-search__header">
			<div class="searchbar">
				<icon
					name="search"
					class="searchbar__icon"
				/>
				<input
					type="text"
					class="searchbar__input"
					v-model="search"
					@keydown="checkSeachBar()"
				/>
				<div
					class="searchbar__clear"
					@click="clear()"
					v-if="search.length"
				>
					<icon name="close" />
				</div>
			</div>

			<button
				class="button button--secondary nc-search__filter-btn"
				@click="showFilter = true"
				:disabled="!products.length"
			>
				<icon
					name="filter"
					class="button__icon"
				/>
				<div class="button__label">
					{{resource('filter')}}
				</div>
			</button>
			<button
				class="button button--secondary nc-search__sort-btn"
				:disabled="!products.length"
				@click="showSort = true"
			>
				<icon
					name="sort"
					class="button__icon"
				/>
				<div class="button__label">{{resource('sort')}}</div>
			</button>
		</div>
		<div
			class="nc-search__filters"
			v-if="filterBy.length"
		>
			{{resource('filterBy')}}
			<button
				class="nc-search__filter button button--outline button--secondary"
				v-for="item in filterBy"
				:key="item.filter.name"
				@click="clearFilter(item)"
			>
				<span class="button__text">{{item.filter.name}}</span>
				<icon
					name="close"
					class="button__icon"
				></icon>
			</button>
		</div>
		<transition name="fade">
			<div
				class="nc-search__body nc-table"
				v-show="products.length > 0 && !loading"
			>
				<div class="results__header result">
					<div class="result__img"></div>
					<div class="result__title">{{resource('title')}}</div>
					<div class="result__ean">{{resource('EAN')}}</div>
					<div class="result__brand">{{resource('brand')}}</div>
					<div class="result__orderQuantity">{{resource('bulk')}}</div>
					<div class="result__price">{{resource('pricePerPiece')}}</div>
					<div class="result__amount">{{resource('quantity')}}</div>
					<div class="result__add"></div>

				</div>

				<DynamicScroller
					:items="products"
					:min-item-size="93"
					class="nc-table__list"
					key-field="id"
					ref="productlist"
				>
					<template v-slot="{ item, index, active }">
						<DynamicScrollerItem
							:item="item"
							:active="active"
							:data-index="index"
						>
							<catalogProduct
								v-model="item"
								@add="addProduct($event)"
							/>
						</DynamicScrollerItem>
					</template>
				</DynamicScroller>
			</div>
		</transition>
		<transition>
			<div
				class="nc-search__body nc-search__body--loading"
				v-show="products.length === 0 && loading"
			>
				<icon
					class="loader__icon"
					size="2em"
					name="loader"
					:animation="{name:'rotate', duration: '1.5s', repeat:'infinite'}"
				/>
			</div>
		</transition>
		<transition>
			<div
				class="nc-search__body nc-search__body--no-result"
				v-show="products.length === 0 && hasBeenUsed && !loading"
			>
				{{resource('noResult')}}
			</div>
		</transition>
		<nc-overlay v-model="showSort">
			<template #title>{{resource('sort')}}</template>
			<template #default>
				<div class="sorting">
					<label
						class="sorting__option"
						:key="item"
						v-for="item in sorting"
					>
						<input
							type="radio"
							class="sorting__radio"
							:value="item"
							v-model="sortBy"
							@change="showSort = false"
						/>
						<div class="sorting__title">{{resource(item)}}</div>
					</label>
				</div>
			</template>
		</nc-overlay>
		<nc-overlay v-model="showFilter">
			<template #title>{{resource('filter')}}</template>
			<template #default>
				<nc-filtering
					v-model="filtering"
					:totalHits="result.totalResultCount"
					@close="showFilter = false"
				/>
			</template>
		</nc-overlay>
		<div class="test">
			{{test}}
		</div>
	</div>
</template>
<style lang="scss">
.test {
	position: fixed;
	left: 0;
	bottom: 0;
	background: #ffffff;
}
.nc-search {
	height: 100%;
	box-sizing: border-box;
	&.search__content {
		background: #f5f5f5;
		display: flex;
		flex-direction: column;
		margin: 0;
		padding: $content;
	}
	.searchbar {
		flex: 1 1 auto;
		background: #fff;
		border-radius: 3px;
		overflow: hidden;
		margin-right: $container;
		padding: 0 0 0 1em;
		&__icon {
			margin-right: 0.5em;
		}
		&__clear {
			cursor: pointer;
			padding: 10px 1em;
		}
	}
	&__header {
		display: flex;
		justify-content: center;
		padding-bottom: $content;
	}
	&__body {
		overflow: hidden;
		&--no-result {
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			background: #fff;
		}
		&--loading {
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
	&__filter-btn,
	&__sort-btn {
		margin-left: $component;
		background: $secondary;
		color: #fff;
		border: none;
		font-size: $fs1;
		padding: 0 $content;
		border-radius: 3px;
	}
	&__filters {
		text-align: center;
		margin-bottom: $content;
	}
	&__filter {
		margin-left: $component;
		.button__icon {
			width: 0.7em;
			height: 0.7em;
		}
	}
}
.nc-table {
	&__list {
		background: #fff;
		height: calc(100% - 40px);
	}
	.results__header {
		background: $nc-catalog__header-bg;
		color: $nc-catalog__header-color;
		height: 40px;
	}
}

.sorting {
	&__option {
		display: flex;
		padding: $content;
		cursor: pointer;
		border-bottom: 1px solid #ccc;
		&:first-child {
			border-top: 1px solid #ccc;
		}
	}
	&__radio {
		margin-right: $component;
	}
}
input[type="radio"] {
	appearance: none;
	margin: 0 $content 0 0;
	padding: 0;
	border: 1px solid #ccc;
	width: 18px;
	height: 18px;
	border-radius: 100%;
	background: #fff;
	display: block;
	&:checked {
		background: radial-gradient(ellipse at center, #00a3d2 32%, #ffffff 36%);
	}
}
</style>
<script>
import ncOverlay from './nc-overlay'
import ncFiltering from './nc-filtering'
import catalogProduct from '@/components/app-catalogProduct.vue'
import { clearTimeout, setTimeout } from 'timers'
import { searchClient } from '@/searchClient'


export default {
	name: 'nc-search',
	components: {
		ncOverlay,
		ncFiltering,
		catalogProduct
	},
	mounted () {
		let $this = this
		this.$refs.productlist.$el.addEventListener('scroll', function (e) {
			let element = this
			$this.checkScroll(element)
		})

	},
	methods: {
		addProduct (e) {
			this.$emit('addProduct', e)
		},
		resource (input) {
			var lang = this.$store.getters.language
			var translate = this.res[lang][input]
			if (translate) {
				return translate
			}
			return input
		},
		checkSeachBar () {
			let $this = this
			clearTimeout(this.searchTimer)
			this.searchTimer = setTimeout(function () {
				if ($this.search.length >= 2) {
					$this.$set($this, 'hasBeenUsed', true)
					$this.$set($this, 'sortBy', 'relevance')
					$this.doSearch()
				}
			}, 350) // delay for search
		},
		clear () {
			this.$set(this, 'search', '')
			this.$set(this, 'result', {})
		},
		clearFilter (filterItem) {
			let filterIndex = this.filtering[filterItem.categoryIndex].facets.findIndex(i=> i.name === filterItem.filter.name)
			this.$set(this.filtering[filterItem.categoryIndex].facets[filterIndex], 'isSelected', false)
		},
		doSearch (lazy) {
			this.loading = true
			let config = {
				query: this.query,
				body: this.body
			}
			if(lazy){
				config.query = this.lastQuery + `&skip=${this.paging.skip}`
			}

			searchClient(config, lazy).then(response =>{
				if(lazy){
					this.$set(this.result, 'documents', this.result.documents.concat(response.data.result.documents))
					this.$set(this.paging, 'lazyPossible', this.paging.total < this.result.documents.length)

					// update skip to set up for next call
					this.paging.skip += this.paging.take
				}else{
					let result = response.data.result
					this.result = result

					this.$set(this, 'filtering', [...result.facets])
					this.$set(this, 'paging', {
						take: this.paging.take,
						skip: this.paging.take,
						total: this.result.totalResultCount,
						lazyPossible: this.result.totalResultCount > this.result.documents.length
					})
					this.lastQuery = this.query
				}
			}).finally(()=>{
				this.$nextTick(()=>{
					this.loading = false
				})
			})
		},
		checkScroll (element) {
			let scrolledWrapper = element.querySelector('.vue-recycle-scroller__item-wrapper')

			let total = scrolledWrapper.clientHeight

			let height = element.clientHeight
			let scrolled = element.scrollTop
			let pos = scrolled + height

			// almost at bottom, lazyload more
			if (pos >= total && this.paging.lazyPossible) {
				this.doSearch(true)
			}
		},
	},
	watch: {
		query(val){
			if(val !== this.lastQuery && !this.loading){
				this.doSearch()
			}
		},
		body:{
			handler(newVal, oldVal){
				if(!this.loading && JSON.stringify(newVal) !== JSON.stringify(oldVal)){
					this.doSearch()
				}
			},
			deep: true
		}
	},
	computed: {
		clientGroup(){
			let user = this.$store.getters.user
			if(user.profile.group === '990bab1f-ce1f-46c0-b144-9675c7db6ec0'){
				return '&owner=OHC'
			}
			return null
		},
		filterBy(){
			let activeFilters = []
			this.filtering.forEach((category, categoryIndex) =>{
				let selected = category.facets.filter(i=>i.isSelected)
				selected.forEach(filter=>{
					activeFilters.push({
						categoryIndex,
						filter
					})
				})
			})
			return activeFilters
		},
		query () {
			let lang = this.$store.state.app.language
			let query = `https://pgz-gateway.nextchapter-ecommerce.com/api/search?language=${lang}&term=${this.search}`

			if (this.sortBy.length) {
				query += `&orderBy=${encodeURIComponent(this.sortBy)}`
			}
			if(this.clientGroup){
				query += this.clientGroup
			}

			query += `&take=${this.paging.take}`
			return query
		},
		body(){
			let filters = []
			this.filtering.forEach(category =>{
				let categoryIndex = filters.findIndex(filter=>{
					return filter.name === category.name
				})
				category.facets.forEach(i => {
					if(i.isSelected){
						if(filters.length && categoryIndex >= 0){
							filters[categoryIndex].values.push(i.name)
						} else {
							filters.push({ name: category.name, values: [i.name]})
							categoryIndex = filters.length - 1
						}
					}
				})
			})
			return { filters }
		},
		products () {
			if (this.result.documents) {
				let items = this.result.documents.map(i => i.values)
				let eans = items.map(i => i.eanCode)
				let products = []
				eans.forEach(ean => {
					if (this.$store.getters.product(ean)) {
						products.push(this.$store.getters.product(ean))
					}
				})

				return products
			}
			return []
		}
	},
	data () {
		return {
			test: '',
			lastQuery: '',
			hasBeenUsed: false,
			loading: false,
			paging: {
				skip: 0,
				take: 50,
				lazyPossible: null,
				total: null
			},

			result: {},
			search: '',
			searchTimer: null,
			category: '',
			subcategory: '',
			subsubcategory: '',
			subsubsubcategory: '',

			showFilter: false,
			filtering: [],

			showSort: false,
			sorting: ['relevance', 'price|asc', 'price|desc', 'name|asc', 'name|desc'],
			sortBy: 'relevance',

			res: {
				nl: {
					title: 'Titel',
					EAN: 'EAN',
					brand: 'Merk',
					bulk: 'BE',
					pricePerPiece: 'Prijs p/s',
					quantity: 'Aantal',
					filter: 'Filteren',
					sort: 'Sorteren',
					relevance: 'Relevantie',
					'price|asc': 'Prijs (laag-hoog)',
					'price|desc': 'Prijs (hoog-laag)',
					'name|asc': 'Titel (A-Z)',
					'name|desc': 'Titel (Z-A)',
					filterBy: 'Gefilterd op: ',
					noResult: 'Uw zoekopdracht heeft helaas geen resultaat opgeleverd. Probeer een andere zoekterm.'
				},
				fr: {
					title: 'Titre',
					EAN: 'EAN',
					brand: 'Marque',
					bulk: 'QO',
					pricePerPiece: 'Prix p / s',
					quantity: 'Montant',
					filter: 'Filtrer',
					sort: 'Sorte',
					relevance: 'Pertinence',
					'price|asc': 'Prix (bas-élevé)',
					'price|desc': 'Prix (élevé-bas)',
					'name|asc': 'Titre (A-Z)',
					'name|desc': 'Titre (Z-A)',
					filterBy: 'Filtré sur: ',
					noResult: 'Malheureusement, votre recherche n\'a donné aucun résultat. Essayez un terme de recherche différent.'
				}
			}
		}
	}
}
</script>
